import { useContext } from 'react';
import Untabbable from './Untabbable';
export default function useTabIndex(value) {
  var inert = useContext(Untabbable.Context);
  return inert ? -1 : value;
}